import { LANGUAGE } from "@/common/utils/constants.js";

export const CLIENT_CONTEXT_DOCX = {
	[LANGUAGE.en.short]: {
		title: `Client Context`
	},
	[LANGUAGE.de.short]: {
		title: `Kundenkontext`,
	},
	[LANGUAGE.fr.short]: {
		title: `Contexte client`
	},
	[LANGUAGE.it.short]: {
		title: `Contesto del cliente`
	},
	[LANGUAGE.ja.short]: {
		title: `クライアントコンテキスト`
	},
	[LANGUAGE.es.short]: {
		title: `Contexto del cliente`
	},
}
